module.exports = __webpack_public_path__ + "img/pic13.f93fe2df.png";